import React from 'react';

export default function Input(props) {
  if (props.type === 'notification') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
        <label style={{ margin: 0, textAlign: 'left' }}>{props.label}</label>
        <select onChange={(e) => props.setValue(e.target.value)} defaultValue={props?.defaultValue}>
          {
            props.options.length > 0
              ? props.options.map((item) => (
                <option value={item.push_type}>{item.push_type}</option>
              ))
              : <option>----</option>
          }

        </select>

      </div>
    );
  }

  if (props.type === 'select') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
        <label style={{ margin: 0, textAlign: 'left' }}>{props.label}</label>
        <select onChange={(e) => props.setValue(e.target.value)} style={{ padding: '1px 2px', height: '30px' }}>
          {
            props.options.length > 0
              ? props.options.map((item) => (
                <option value={item} selected={item == props.defaultValue}>{item}</option>
              ))
              : <option>----</option>
          }

        </select>

      </div>
    );
  }

  if (props.type === 'number') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
        <label style={{ margin: 0, textAlign: 'left' }}>{props.label}</label>
        <input
          type={props.type}
          id={props.id}
          defaultValue={props.defaultValue}
          value={props.value}
          min={props.min || 0}
          step="0.01"
          name={props.name}
          disabled={props.disabled}
          onChange={(e) => props.setValue(e.target.value.replace(/^0+/, ''))}
        />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
      <label style={{ margin: 0, textAlign: 'left' }}>{props.label}</label>
      <input
        type={props.type}
        id={props.id}
        defaultValue={props.defaultValue}
        value={props.value}
        min={props.min || 0}
        name={props.name}
        disabled={props.disabled}
        onChange={(e) => props.setValue(e.target.value)}
      />
    </div>
  );
}
